import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

type HelpTipProps = {
  text: string;
  size?: 'small' | 'medium';
};

export default function HelpTip({ text, size = 'small' }: HelpTipProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton size={size} onClick={(e) => setAnchorEl(e.currentTarget)} aria-label="help">
        <HelpOutlineIcon fontSize={size} />
      </IconButton>
      <Popover
        open={anchorEl !== null}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Typography variant="body2" sx={{ p: 2, maxWidth: 360 }}>
          {text}
        </Typography>
      </Popover>
    </>
  );
}
